export * from './spare-models.component';
export * from './spare-model-add/add.component';
export * from './spare-model-edit/edit.component';
export * from './spares.component';
export * from './spare-edit/edit.component';
// export * from './function-loss-edit/edit.component';
export * from './spare-model-asset-list/spare-model-asset-list.component';
export * from './import/import.component';
